import {
    createContext,
    useContext,
    useEffect
} from "react";
import type {
    StatTileContextType,
    StatTilePartKind
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const STAT_TILE_PART_NAMES: Record<StatTilePartKind, string> = {
    delta: "Delta",
    title: "Title",
    value: "Value"
};

export const StatTileContext = createContext<StatTileContextType | undefined>(undefined);

export const useStatTileContext = ({
    part
}: {
    part: StatTilePartKind;
}): StatTileContextType | undefined => {
    const context = useContext(StatTileContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `StatTile.${STAT_TILE_PART_NAMES[part]}: must be rendered inside <StatTile>.`
        });
    }, [
        context,
        part
    ]);

    return context;
};
